import React, { useState } from 'react'
import { Text, View } from 'react-native'
import { tv } from 'tailwind-variants'

import { useTranslation } from '@flows-ui/utils/i18n'
import type { ProductExtension } from '@flows/index'
import Spacer from '@ui-kit/components/layoutComponents/Spacer'
import { h3 } from '@ui-kit/core/typography'

import { SubGroupAccordion } from './SubGroupAccordion'

const { container, divider } = tv({
  slots: {
    container: 'pt-12',
    divider: 'h-px bg-grey-200',
  },
})()

export const ExtensionCoverageSection = ({ extension }: { extension: ProductExtension }) => {
  const [expandedItem, setExpandedItem] = useState<string | null>(null)
  const { t } = useTranslation()
  const subGroups = extension.contentSubGroups ?? []

  if (subGroups.length === 0) {
    return null
  }

  return (
    <View className={container()}>
      <Text className={h3()}>{t('sharedFlows_common:steps.quote.yourCoverage.title')}</Text>
      <Spacer size="small" />
      {subGroups.map((subGroup, index) => {
        const isLastSubGroup = index === subGroups.length - 1
        return (
          <React.Fragment key={subGroup.itemKey?.current ?? subGroup.title}>
            <SubGroupAccordion
              subGroup={subGroup}
              expandedItem={expandedItem}
              onToggleItem={setExpandedItem}
            />
            {!isLastSubGroup && <View className={divider()} />}
          </React.Fragment>
        )
      })}
    </View>
  )
}
